import React, { useEffect, useState } from "react";

export default function Mode() {
    const [isSwitched, setIsSwitched] = useState(true);
    const [isAnimated, setIsAnimated] = useState(true);

    useEffect(() => {
        setIsAnimated(false)
    }, [isSwitched]);

    useEffect(()=>{
        if(!isAnimated) return
        window.document.body.className = isSwitched ? "dark" : "light";
    },[isAnimated])

    return (
        <>
            <div
                className={`overlay ${isSwitched ? 'dark': 'light'}`}
                style={!isAnimated ? { transform: "translate(-25%, 25%)" } : {}}
                onTransitionEnd={() => setIsAnimated(true)}
            ></div>
            <div className="mode"  onClick={() =>setIsSwitched(!isSwitched)}>
                <div className="mode-circle" ></div>
            </div>
        </>
    );
}
